module.exports = __webpack_public_path__ + "img/unified-app-launch.d9f89d6a.svg";